import React, { useEffect, useState } from "react";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation } from "react-router-dom";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const CheckPoints = ({ onClose }) => {
  const [points, setPoints] = useState(0);
  const [amountToAdd, setAmountToAdd] = useState("");
  const [secretCode, setSecretCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [message, setMessage] = useState("");
  const location = useLocation();

  useEffect(() => {
    fetchPoints();
    const params = new URLSearchParams(location.search);
    if (params.get("payment_success") === "true") {
      alert("Payment was successful! Fetching updated points...");
      fetchPoints();
    }
  }, [location]);

  const fetchPoints = async () => {
    try {
      const response = await axios.get(
        "https://genz-staging.feeltiptop.com/api/payment/get-points",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      const fetchedPoints = parseFloat(response.data.Points) || 0;
      console.log("fetched points: ", fetchedPoints);
      setPoints(fetchedPoints);
    } catch (error) {
      console.error(
        "Error fetching points:",
        error.response ? error.response.data : error.message,
      );
    }
  };

  const handleAddtoPoints = async () => {
    const parsedAmount = parseFloat(amountToAdd);
    const user_id = localStorage.getItem("user_id");

    if (isNaN(parsedAmount) || parsedAmount <= 0) {
      setMessage("Please enter a valid amount greater than 0.");
      return;
    }

    // Check for minimum amount (50 points)
    if (parsedAmount < 50) {
      setMessage("The minimum amount to add is 50 points.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "https://genz-staging.feeltiptop.com/api/payment/create-checkout-session",
        {
          user_id: user_id,
          payment_amount: parsedAmount,
          transaction_type: "add",
          secretCode: secretCode,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (process.env.REACT_APP_TEST_MODE === "true") {
        console.log("points: ", points);
        console.log("parsedAmount: ", parsedAmount);

        const updatedPoints = parseFloat(points) + parsedAmount;
        console.log("updatedPoints: ", updatedPoints);

        setPoints(updatedPoints);
        setAmountToAdd("");
        setSecretCode("");
        setLoading(false);
        return;
      }

      if (response.data && response.data.id) {
        const stripe = await stripePromise;
        const { error } = await stripe.redirectToCheckout({
          sessionId: response.data.id,
        });
        if (error) {
          console.error("Error redirecting to Stripe Checkout:", error);
          alert(
            "An error occurred while redirecting to Stripe Checkout. Please try again.",
          );
        }
      } else {
        console.error(
          "Checkout session ID not found in response:",
          response.data,
        );
      }
    } catch (error) {
      console.error(
        "Error creating checkout session:",
        error.response ? error.response.data : error.message,
      );
      alert(
        "An error occurred while creating the checkout session. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative w-[500px] rounded-2xl bg-white p-6 shadow-md">
      <button
        onClick={onClose}
        className="absolute right-5 top-5 rounded-lg px-3 py-2 text-right font-semibold shadow-sm"
      >
        X
      </button>
      <div className="mb-6 text-left">
        <h2 className="text-2xl font-normal text-gray-800">Add your card</h2>
        <p className="m-0 text-gray-600">
          Available points:{" "}
          <span className="font-semibold">{points.toLocaleString()}</span>
        </p>
      </div>

      <div className="flex flex-col space-y-3">
        <input
          type="text"
          placeholder="Enter Secret Code (Optional)"
          className="h-12 w-full rounded-2xl border border-gray-800 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
          value={secretCode}
          onChange={(e) => setSecretCode(e.target.value)}
        />

        <input
          type="number"
          value={amountToAdd}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              setAmountToAdd(value);
            }
          }}
          className="h-12 w-full rounded-2xl border border-gray-800 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
          placeholder="Enter amount in 360 points (e.g., 100, 200)"
        />

        <div className="flex justify-end">
          <button
            onClick={handleAddtoPoints}
            className={`rounded-2xl bg-blue-800 px-5 py-2 text-sm font-semibold text-white transition duration-200 hover:bg-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-400 ${
              loading || !amountToAdd || parseFloat(amountToAdd) > points
                ? "cursor-not-allowed opacity-50"
                : ""
            }`}
            disabled={loading || !amountToAdd || parseFloat(amountToAdd) <= 0}
          >
            {loading ? "Adding..." : "Submit"}
          </button>
        </div>

        {message && (
          <p
            className={`mt-2 text-sm font-medium ${
              message.includes("minimum") ? "text-red-600" : "text-green-600"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default CheckPoints;
